module.exports = __webpack_public_path__ + "8a9d28a50a74512b2a57cd610f9e1538.svg";